import { MapMarkerCheckOutlineIcon } from './MapMarkerCheckOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 76C82A3D-F79E-46D9-8234-456F39A35567
 * name map-marker-check-outline
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/map-marker-check-outline.svg
 * tags
 * - Navigation 
 * - Geographic Information System 
 */
export const WhereToVoteOutlineIcon = MapMarkerCheckOutlineIcon;
export default WhereToVoteOutlineIcon